module.exports = __webpack_public_path__ + "static/media/20250225_090947.bcdaa687.webp";